/**
 * Japanese yen.
 */
export var JPY = {
  code: 'JPY',
  base: 10,
  exponent: 0
};